export default {
  'dashboard.monitor.trading-activity': '活动实时交易情况',
  'dashboard.monitor.total-transactions': '今日交易总额',
  'dashboard.monitor.sales-target': '销售目标完成率',
  'dashboard.monitor.remaining-time': '活动剩余时间',
  'dashboard.monitor.total-transactions-per-second': '每秒交易总额',
  'dashboard.monitor.activity-forecast': '活动情况预测',
  'dashboard.monitor.efficiency': '券核效率',
  'dashboard.monitor.ratio': '跳出率',
  'dashboard.monitor.proportion-per-category': '各品类占比',
  'dashboard.monitor.fast-food': '中式快餐',
  'dashboard.monitor.western-food': '西餐',
  'dashboard.monitor.hot-pot': '火锅',
  'dashboard.monitor.waiting-for-implementation': 'Waiting for implementation',
  'dashboard.monitor.popular-searches': '热门搜索',
  'dashboard.monitor.resource-surplus': '资源剩余',
  'dashboard.monitor.fund-surplus': '补贴资金剩余',
};
